"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme, props, state) {
  var _theme = theme,
      palette = _theme.palette,
      inputWidth = (0, _pixelToNumber["default"])(theme.fontSize) * props.maxLength + (0, _pixelToNumber["default"])(theme.paddingLeft) + (0, _pixelToNumber["default"])(theme.paddingRight) + 'px',
      wrappedBorder = !/none/.test(theme.borderStyle),
      passiveBorderOpacity = wrappedBorder || props.disabled ? 0 : 1,
      activeBorderOpacity = wrappedBorder ? 0 : 1,
      fieldBorder = {},
      fieldBorderFocused = {},
      field = {},
      activeBorder = {};

  if (props.wide) {
    inputWidth = "calc(".concat(100 / props.count, "% - ").concat(palette.gutter * (props.count - 1) / props.count, "px)");
  }

  theme = _objectSpread({}, theme, {
    color: theme.idleColor,
    placeholder: theme.idlePlaceholder,
    labelColor: theme.idleLabelColor,
    borderColor: theme.idleBorderColor,
    borderStyle: theme.idleBorderStyle,
    borderWidth: theme.idleBorderWidth,
    borderTransform: theme.idleBorderTransform,
    borderRadius: theme.idleBorderRadius,
    background: theme.idleBackground,
    boxShadow: theme.idleBoxShadow,
    outline: theme.idleOutline
  });

  if (state.hover) {
    theme = _objectSpread({}, theme, {
      color: theme.hoverColor,
      placeholder: theme.hoverPlaceholder,
      labelColor: theme.hoverLabelColor,
      borderColor: theme.hoverBorderColor,
      borderStyle: theme.hoverBorderStyle,
      borderWidth: theme.hoverBorderWidth,
      borderTransform: theme.hoverBorderTransform,
      borderRadius: theme.hoverBorderRadius,
      background: theme.hoverBackground,
      boxShadow: theme.hoverBoxShadow,
      outline: theme.hoverOutline
    });
  }

  if (state.focus) {
    theme = _objectSpread({}, theme, {
      // color: theme.focusColor,
      // placeholder: theme.focusPlaceholder,
      labelColor: props.error ? theme.errorLabelColor : theme.focusLabelColor // borderColor: theme.focusBorderColor,
      // borderStyle: theme.focusBorderStyle,
      // borderWidth: theme.focusBorderWidth,
      // borderTransform: theme.focusBorderTransform,
      // borderRadius: theme.focusBorderRadius,
      // background: theme.focusBackground,
      // boxShadow: theme.focusBoxShadow,
      // outline: theme.focusOutline,

    });
  }

  if (props.error) {
    theme = _objectSpread({}, theme, {
      color: theme.errorColor,
      placeholder: theme.errorPlaceholder,
      borderColor: theme.errorBorderColor,
      borderStyle: theme.errorBorderStyle,
      borderWidth: theme.errorBorderWidth,
      borderTransform: theme.errorBorderTransform,
      borderRadius: theme.errorBorderRadius,
      background: theme.errorBackground,
      boxShadow: theme.errorBoxShadow,
      outline: theme.errorOutline
    });
  }

  if (props.disabled) {
    theme = _objectSpread({}, theme, {
      color: theme.disabledColor,
      placeholder: theme.disabledPlaceholder,
      labelColor: theme.disabledLabelColor,
      borderStyle: theme.disabledBorderStyle,
      borderColor: theme.disabledBorderColor,
      borderWidth: theme.disabledBorderWidth,
      borderTransform: theme.disabledBorderTransform,
      borderRadius: theme.disabledBorderRadius,
      background: theme.disabledBackground,
      boxShadow: theme.disabledBoxShadow,
      outline: theme.disabledOutline
    });
  }

  if (wrappedBorder) {
    fieldBorder = {
      borderStyle: theme.borderStyle,
      borderColor: theme.borderColor,
      borderWidth: theme.borderWidth,
      borderRadius: theme.borderRadius
    };
    fieldBorderFocused = {
      borderColor: theme.focusBorderColor,
      borderStyle: theme.focusBorderStyle,
      borderWidth: theme.focusBorderWidth,
      borderRadius: theme.focusBorderRadius
    };
  }

  field = _objectSpread({
    width: '100%',
    paddingBottom: theme.paddingBottom,
    paddingTop: theme.paddingTop,
    paddingLeft: theme.paddingLeft,
    paddingRight: theme.paddingRight,
    background: theme.background,
    fontSize: theme.fontSize,
    lineHeight: theme.lineHeight,
    fontWeight: theme.fontWeight,
    transitionProperty: 'all',
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    position: 'relative',
    textAlign: 'center',
    margin: 0,
    border: '0 none',
    outline: theme.outline,
    color: theme.color,
    boxShadow: theme.boxShadow,
    boxSizing: 'border-box'
  }, fieldBorder, {
    '&::placeholder': {
      color: theme.placeholder
    }
  });
  activeBorder = {
    borderImage: 'none',
    borderStyle: theme.borderStyle,
    borderWidth: "medium medium ".concat(theme.borderWidth),
    boxSizing: 'content-box',
    height: 0,
    margin: 0,
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: 'ease',
    transitionProperty: 'opacity, transform, border',
    width: '100%',
    position: 'absolute',
    bottom: 0,
    borderColor: theme.borderColor,
    transform: theme.borderTransform,
    opacity: activeBorderOpacity
  };
  return {
    root: {
      display: theme.display,
      width: theme.width,
      minWidth: theme.minWidth
    },
    contentWrapper: {
      position: 'relative',
      font: "".concat(palette.tsNormal, "/").concat(palette.tlNormal, " \"").concat(theme.fontFamily, "\""),
      textAlign: 'left',
      color: theme.color,
      outline: theme.outline
    },
    wrapper: {
      width: inputWidth,
      display: 'inline-block',
      position: 'relative',
      zoom: 1,
      '&:after': {
        clear: 'both',
        content: '""',
        display: 'block',
        height: 0
      },
      '&:not(:last-of-type)': {
        marginRight: palette.gutter + 'px'
      }
    },
    label: {
      color: theme.labelColor,
      fontSize: theme.labelFontSize,
      lineHeight: theme.labelLineHeight,
      transitionProperty: 'color',
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction,
      display: 'block'
    },
    field: field,
    fieldFocused: _objectSpread({}, field, {}, fieldBorderFocused, {
      color: theme.focusColor,
      placeholder: theme.focusPlaceholder,
      background: theme.focusBackground,
      boxShadow: theme.focusBoxShadow,
      outline: theme.focusOutline
    }),
    border: {
      borderImage: 'none',
      borderStyle: 'none none solid',
      boxSizing: 'content-box',
      height: 0,
      margin: 0,
      width: '100%',
      position: 'absolute',
      bottom: 0,
      borderColor: theme.idleBorderColor,
      borderWidth: "medium medium ".concat(theme.idleBorderWidth),
      opacity: passiveBorderOpacity
    },
    activeBorder: activeBorder,
    activeBorderFocused: _objectSpread({}, activeBorder, {
      borderColor: theme.focusBorderColor,
      borderStyle: theme.focusBorderStyle,
      borderWidth: theme.focusBorderWidth,
      transform: theme.focusBorderTransform
    })
  };
}